__turbopack_context__.v({
  "circleAvatar": "P94bzW_circleAvatar",
});
